<template>
  <div class="manager">
    <span v-if="showType" class="manager__title txt-3-alt">
      {{ _userType }}:
    </span>
    <span class="manager__avatar">
      <avatar :username="name" :src="image" :size="30" />
    </span>
    <span class="manager__name txt-2-alt" v-if="showName && name">
      <router-link
        v-if="id"
        :to="{ name: 'campaigns', query: { manager: id } }"
      >
        {{ name }}
      </router-link>
      <span v-else>{{ name }}</span>
    </span>
  </div>
</template>

<script>
import avatar from 'vue-avatar';

export default {
  props: {
    userType: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    showName: {
      type: Boolean,
      default: true
    },
    showType: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: 0
    }
  },

  components: {
    avatar
  },

  computed: {
    _userType() {
      return this.userType !== '' ? this.userType : this.$tc('manager', 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.manager {
  display: flex;
  align-items: center;

  &__avatar {
    margin-right: 0.4rem;
  }

  &__title {
    margin-right: 0.4rem;
  }

  &__name {
    a {
      color: #242527;
      transition: all 0.2s ease-in-out;

      &:hover {
        text-decoration: none;
        color: #2ea8ed;
      }
    }
  }
}
</style>
